import React from 'react';
import { Flex, SpacingStack, TextV2, Toggle } from '@withjoy/joykit';
import { Tip } from '@withjoy/joykit/icons';
import { styles } from '../../CashFundPaymentMethod.style';
import { useSharedRegistryTranslations } from '@apps/registry/SharedRegistry.i18n';
import { FormikProps } from 'formik';
import { AddCashFundDialogFields } from '../../../../types';
import { DonationFundPlatformTypeEnum } from '@graphql/generated';
import { PaymentMethodOption } from '@shared/utils/paymentMethodOptions';
import { AppPlatformSelect } from './components/AppPaymentPlatformSelect/AppPlatformSelect';

interface AppPlatformToggleProps {
  formik: FormikProps<AddCashFundDialogFields>;
  isMobile: boolean;
  setPaymentMethod: (paymentMethod?: DonationFundPlatformTypeEnum) => void;
  selectedPaymentMethod: Maybe<PaymentMethodOption>;
  paymentLink: string;
  onUsernameFocus: React.ChangeEventHandler<HTMLInputElement>;
  isEditDialog?: boolean;
}
export const AppPlatformToggle: React.FC<AppPlatformToggleProps> = props => {
  const { getCashFundDialogTranslations } = useSharedRegistryTranslations();

  const { appPayment, appPaymentDescription, appPaymentNote, proTipTitle, proTipDescription } = getCashFundDialogTranslations();

  return (
    <Flex __css={styles.appPlatFormToggleWrapper()}>
      <Flex rowGap={5} alignItems="center" justifyContent="space-between">
        <SpacingStack spacing={1}>
          <Flex alignItems="center">
            <TextV2 typographyVariant="hed1">{appPayment}</TextV2>
          </Flex>
          <TextV2 typographyVariant="label2" color="mono12">
            {appPaymentDescription}
          </TextV2>
          <TextV2 typographyVariant="label1" color="mono8">
            {appPaymentNote}
          </TextV2>
        </SpacingStack>
        <Flex justifyContent="flex-end">
          <Toggle label="" intent="primary" hideLabel={true} checked={props.formik.values.enableAppPlatform} name="enableAppPlatform" onChange={props.formik.handleChange} />
        </Flex>
      </Flex>
      {props.formik.values.enableAppPlatform && <AppPlatformSelect {...props} />}
      {!props.formik.values.enableJoyCredit && props.formik.values.enableAppPlatform && (
        <Flex padding={5} background="#FFFBF6" borderRadius={2}>
          <Tip />
          <Flex flexDirection="column" marginLeft={5}>
            <TextV2 typographyVariant="hed1" color="mono14" marginBottom={3}>
              {proTipTitle}
            </TextV2>
            <TextV2 typographyVariant="body1" color="mono12">
              {proTipDescription}
            </TextV2>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
